import './assets/scss/custom.scss';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './App.scss'
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
// import './assets/css/style.css'
// import "./App.scss";

import {Provider as ReduxProvider} from "react-redux";
import {store} from "./store/index";
import {ErrorBoundary} from "./ErrorBoundary";

export const customNavigate = {};

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <>
        <React.StrictMode>
            <ReduxProvider store={store}>
                <ErrorBoundary>
                    <App/>
                </ErrorBoundary>
            </ReduxProvider>
            <ToastContainer/>
        </React.StrictMode>
    </>
);